<template>
  <role-card :creating="isCreating" :id="id"/>
</template>

<script>
import RoleCard from '@/components/app/roles/RoleCard'

export default {
  name: "Role",
  components: {
    RoleCard
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    isCreating() {
      return this.id === 'create'
    },
    isShowing() {
      return !this.isCreating
    }
  },
}
</script>

<style scoped>

</style>